import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function SEOArticlesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-center">
          Mulebuy Spreadsheet Knowledge Library
        </h2>
        <p className="mt-3 text-sm text-foreground-500 font-sans text-center max-w-xl mx-auto">
          Explore our complete collection of in-depth <strong>Mulebuy spreadsheet</strong> guides, comparisons, and expert articles.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-white rounded-xl border border-background-200 hover:border-accent-200 hover:shadow-sm transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '16/9' }}>
                {article.sections[0]?.image ? (
                  <img
                    src={article.sections[0].image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <div className="w-full h-full bg-background-100 flex items-center justify-center">
                    <i className="ri-article-line text-4xl text-foreground-300"></i>
                  </div>
                )}
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-semibold bg-white/90 text-foreground-950 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-sans text-sm font-semibold text-foreground-950 group-hover:text-accent-700 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-400 font-sans line-clamp-2">
                  {article.description}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400 font-sans">
                  <span>{article.readTime}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="text-accent-600 group-hover:translate-x-0.5 transition-transform inline-flex items-center gap-1">
                    Read More <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}